/* global Conf */
import DataRequester from 'react-mobx-admin/services/requester'
import { convertQuery, getTotalItems } from './api_flavor'

export default class CargoDataRequester extends DataRequester {

  constructor (on401) {
    super(convertQuery, getTotalItems, on401, Conf.url)
    this.state = []
  }

  saveEntry (entityName, data, id = null) {
    // this is hack: GET of entity is needed because
    // https://github.com/sequelize/sequelize/issues/2630
    return super.saveEntry(entityName, data, id).then((saved) => {
      return this.getEntry(entityName, saved.id)
    })
  }

  getEntry (entityName, id) {
    return this.call(`/${entityName}/${id}`).then((res) => {
      try {
        this.state = JSON.parse(res.headers['x-detailstate'])
      } catch (_) {
        this.state = []
      }
      return res.data
    })
  }

}
